/* global axios */
import ApiClient from './ApiClient';

class MessageTemplatesAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  get(inboxId) {
    return axios.get(`${this.url}/${inboxId}/message_templates`);
  }

  show(inboxId, id) {
    return axios.get(`${this.url}/${inboxId}/message_templates/${id}`);
  }

  create(inboxId, data) {
    return axios.post(`${this.url}/${inboxId}/message_templates`, {
      message_template: data,
    });
  }

  update(inboxId, id, data) {
    return axios.patch(`${this.url}/${inboxId}/message_templates/${id}`, {
      message_template: data,
    });
  }

  destroy(inboxId, id) {
    return axios.delete(`${this.url}/${inboxId}/message_templates/${id}`);
  }

  submit(inboxId, id) {
    return axios.post(`${this.url}/${inboxId}/message_templates/${id}/submit`);
  }

  duplicate(inboxId, id) {
    return axios.post(
      `${this.url}/${inboxId}/message_templates/${id}/duplicate`
    );
  }

  uploadMedia(inboxId, file, headerType) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('header_type', headerType);
    return axios.post(
      `${this.url}/${inboxId}/message_templates/upload_media`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  }
}

export default new MessageTemplatesAPI();
